import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

const FreeHotel = (props) => {
  const {
    id,
    bgImage,
    flyToMarker,
    hotelInfo,
    hotelName,
    location,
    phoneNumber,
    address,
    category,
    other,
    item,
  } = props;
  return (
    <div className="freeDiv" id={id}>
      <div className="iconDiv">
        <span
          className="fa-layers fa-fw fa-2x markerCircle"
          onClick={flyToMarker}
          key="map"
        >
          <FontAwesomeIcon icon={['fas', 'circle']} className="circle" />
          <FontAwesomeIcon
            icon={['fas', 'map-marker-alt']}
            className="marker"
          />
        </span>
      </div>
      <div className="freeInfoDiv" onClick={hotelInfo}>
        <img
          src={bgImage}
          className="image"
          loading="lazy"
          onError={(e) => (e.target.style.display = 'none')}
          alt=""
        />
        <div className="content">
          <span className="freeHotelName">{hotelName}</span> <br />
          <br />
          <span className="freeHotelAddr">
            {item.city}, {item.addr1} {item.addr2}
          </span>{' '}
          <br />
          {!i18n
            .translate(
              `directory.${item.cat_name
                .replace(/\s/g, '')
                .replace(/&/g, '')
                .replace(/:/g, '')
                .replace(/,/g, '')
                .toLowerCase()
                .replace(/-/g, '')
                .replace(/\+/g, '')}`
            )
            .includes('directory') && (
            <span className="freeHotelCategory">
              {i18n.translate(
                `directory.${item.cat_name
                  .replace(/\s/g, '')
                  .replace(/&/g, '')
                  .replace(/:/g, '')
                  .replace(/,/g, '')
                  .toLowerCase()
                  .replace(/-/g, '')
                  .replace(/\+/g, '')}`
              )}
            </span>
          )}{' '}
          <br />
          <span className="freeHotelPhone">{item.phone}</span> <br />
          <span className="freeHotelPhone">{item.web_url}</span> <br />
          <br />
          <span className="moreInfo">
            {i18n.translate('directoryView.viewNow')}
          </span>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

FreeHotel.propTypes = {
  id: PropTypes.string,
  bgImage: PropTypes.string,
  propertyName: PropTypes.string,
  flyToMarker: PropTypes.func,
  hotelInfo: PropTypes.func,
  hotelName: PropTypes.string,
  location: PropTypes.string,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  category: PropTypes.string,
  other: PropTypes.array,
};

FreeHotel.defaultProps = {
  id: '',
  bgImage: '',
  propertyName: '',
  flyToMarker: () => {},
  hotelInfo: () => {},
  hotelName: '',
  location: '',
  phoneNumber: '',
  address: '',
  category: '',
  other: [],
};

export default FreeHotel;
